/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchActors.defs.js'
export * as $defs from './searchActors.defs.js'
